/**
 * Created by ljybill@aliyun.com  on 2018/4/28
 */
import Ajax from 'flyio'

Ajax.config.timeout = window.wtEnv.networkTimeout
// Ajax.config.baseURL = window.wtEnv.serverBaseUrl
Ajax.config.baseURL = process.env.serverBaseUrl

const UserUrl = {
  getQrCode: '/expert/loadExpertLoginQr',
  checkCode: '/expert/checkCode',
  getUserInfo: '/user/detail',
  getLoginStatus: '/expert/loadExpertLoginStatus',
  fakeExpertLogin: '/expert/fakeExpertLogin',
  getVerifyImg: '/verification/getVerifyImg',
  usernameAndPasswordLogin: '/user/usernameAndPasswordLogin',
  updatePassword: '/user/updatePassword',
  sendSMSCode: '/expert/authCode'
}

const ExpertUrl = {
  getExpertDetail: '/expert/expertDetail',
  updateNicknameAndPhoto: '/expert/updateNicknameAndPhoto',
  restartExpertAuth: '/expert/restartExpertAuth',
  applyExpertCard: '/expert/expertAuth',
  expertWaitReasonQuestion: '/expert/expertWaitReasonQuestionData',
  expertMessageNoReadNum: '/expert/expertMessageNoReadNum',
  expertMessageRead: '/expert/expertMessageRead',
  expertMessageDelete: '/expert/expertMessageDelete',
  answerList: '/expert/myReasonData',
  fansList: '/expert/myFansData',
  organizationLogin: '/expert/organizationLogin',
  expertReasonLikedMessageData: '/expert/expertReasonLikedMessageData',
  expertReasonRepliedMessageData: '/expert/expertReasonRepliedMessageData',
  repliedMessageList: '/expert/repliedMessageList',
  profitList: '/earnings/earningsDetailList',
  myEarnings: '/earnings/myEarnings',
  takeOut: '/earnings/takeOut',
  getTakeList: '/earnings/withdrawRecord',
  appeal: '/earnings/appeal',
  getTakeOutList: '/earnings/takeOutOrderDetailList',
  takeOutDetailList: '/earnings/takeOutDetailList',
  myAllMessage: '/expert/myAllMessage',
  confirmTakeOut: '/earnings/confirmTakeOut'
}

const QuestionUrl = {
  cancelReason: '/question/cancelReason',
  loadUnReadNum: '/question/awaitReasonNumber',
  intoReason: '/question/intoReason',
  getQueryLabel: '/question/queryLabel',
  squareQuestionList: '/question/square',
  getWaitQuestion: '/question/awaitReason',
  rejectReason: '/question/rejectReason',
  responder: '/question/responder',
  getQuestionDetail: '/question/questionDetail',
  getQuestionCommentList: '/question/questionCommentList',
  commentQuestion: '/question/questionComment',
  likeComment: '/question/likeComment',
  commentReply: '/question/commentApply',
  getDraftList: '/question/reasonSaveList',
  saveDraft: '/question/reasonQuestionSave',
  getDraftDetail: '/question/reasonSaveDetail',
  reasonQuestion: '/question/reasonQuestion',
  questionSaveDetail: '/question/questionSaveDetail',
  confirmReason: '/question/confirmReason'
}
const request = function (url, data = {}, queryData = data) {
  let queryString = Object.keys(queryData).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(queryData[key])}`).join('&')
  // TODO
  if (queryString) {
    url = `${url}?${queryString}`
  }
  return Ajax.post(url, data)
}

Ajax.interceptors.request.use((request) => {
  // 给所有请求添加自定义header
  request.headers['x-access-token'] = window.localStorage['token']
  return request
})

Ajax.interceptors.response.use(
  (response) => {
    return response.data
  },
  (err) => {
    // 发生网络错误
    return Promise.resolve('发生网络错误', err)
  }
)

export default {
  getQueryLabel: (data) => request(QuestionUrl.getQueryLabel, data), //获取顶部标签
  cancelReason: (data) => request(QuestionUrl.cancelReason, data), // 取消回答
  confirmReason: (data) => request(QuestionUrl.confirmReason, data), //确认并开始回答
  intoReason: (data) => request(QuestionUrl.intoReason, data), //进入回答界面
  rejectReason: (data) =>request(QuestionUrl.rejectReason, data), //婉拒回答
  responder: (data) => request(QuestionUrl.responder, data), //开始抢答
  getQrCode: (data) => request(UserUrl.getQrCode, data),                         // 获取登录二维码
  getWaitQuestion: (data) => request(QuestionUrl.getWaitQuestion, data),                // 获取待回答问题
  getExpertMessageNoReadNum: (data) => request(ExpertUrl.expertMessageNoReadNum, data),  //消息中心未读数量
  loadUnReadNum: (data) => request(QuestionUrl.loadUnReadNum, data),  //消息中心未读数量
  getUserInfo: (data) => request(UserUrl.getUserInfo, data),                                   // 获取用户信息
  getExpertDetail: (data) => request(ExpertUrl.getExpertDetail, data), // 专家详情
  getQuestion: (data) => request(QuestionUrl.squareQuestionList, data), // 获取问题广场问题
  getAnswerList: (data) => request(ExpertUrl.answerList, data),    // 获取问题列表
  getFansList: (data) => request(ExpertUrl.fansList, data),     // 获取粉丝列表
  getQuestionDetail: (data) => request(QuestionUrl.getQuestionDetail, data),  // 获取问题详情
  getQuestionCommentList: (data) => request(QuestionUrl.getQuestionCommentList, data), // 获取问题评论
  commentQuestion: (data, queryData) => request(QuestionUrl.commentQuestion, data, queryData),   // 评论问题
  likeComment: (data) => request(QuestionUrl.likeComment, data),   // 喜欢某个评论
  commentReply: (data,queryData) => request(QuestionUrl.commentReply, data,queryData),  // 回复评论
  getDraftList: (data) => request(QuestionUrl.getDraftList, data),  // 获取草稿箱列表
  getDraftDetail: (data) => request(QuestionUrl.getDraftDetail, data), // 获取草稿箱详情
  saveDraft: (data, queryData) => request(QuestionUrl.saveDraft, data, queryData),      // 保存草稿
  reasonQuestion: (data, queryData) => request(QuestionUrl.reasonQuestion, data, queryData),  // 提交问题答案
  questionSaveDetail: (data) => request(QuestionUrl.questionSaveDetail, data),  // 获取问题的草稿（如果有）
  getLoginStatus: (data) => request(UserUrl.getLoginStatus, data),    // 获取登录状态
  fakeExpertLogin: (data) => request(UserUrl.fakeExpertLogin, data),    //  托专家登录
  expertMessageRead: (data) => request(ExpertUrl.expertMessageRead, data),    //  消息中心标为已读
  expertMessageDelete: (data) => request(ExpertUrl.expertMessageDelete, data),    //  消息中删除
  organizationLogin: (data) => request(ExpertUrl.organizationLogin, data),    //  机构登录
  getExpertReasonLikedMessageData: (data) => request(ExpertUrl.expertReasonLikedMessageData, data),    //  消息中新点赞数据
  getExpertReasonRepliedMessageData: (data) => request(ExpertUrl.expertReasonRepliedMessageData, data),    //  消息评论
  getRepliedMessageList: (data) => request(ExpertUrl.repliedMessageList, data),    //  消息我的
  getProfitList: (data) => request(ExpertUrl.profitList, data),     // 获取我的收益明细列表
  myEarnings: (data) => request(ExpertUrl.myEarnings, data),  // 获取我的收益
  takeOut: (data) => request(ExpertUrl.takeOut, data),     // 获取提现信息
  getTakeList: (data) => request(ExpertUrl.getTakeList, data), // 获取提现记录
  appeal:  (data) => request(ExpertUrl.appeal, data),    // 申诉
  getTakeOutList:  (data) => request(ExpertUrl.getTakeOutList, data),    // 提现记录详情
  takeOutDetailList:  (data) => request(ExpertUrl.takeOutDetailList, data),    // 获取核对账单列表
  myAllMessage:   (data) => request(ExpertUrl.myAllMessage, data),   // 获取我的所有消息列表
  confirmTakeOut:  (data) => request(ExpertUrl.confirmTakeOut, data),    // 确认提现
  getVerifyImg: () => request(UserUrl.getVerifyImg), // 获取滑块验证码
  usernameAndPasswordLogin: (data) => request(UserUrl.usernameAndPasswordLogin, data),    //  专家登录
  sendSMSCode: (data) => request(UserUrl.sendSMSCode, data),    //  发验证码
  updatePassword: (data) => request(UserUrl.updatePassword, data),    //  修改密码
  checkCode: (data) => request(UserUrl.checkCode, data),    //  校验验证码
  updateNicknameAndPhoto: (data) => request(ExpertUrl.updateNicknameAndPhoto, data),    //  发验证码
  restartExpertAuth: (data) => request(ExpertUrl.restartExpertAuth, data),    //  重新审核
  applyExpertCard: (data) => request(ExpertUrl.applyExpertCard, data)    //  申请答主
}



// WEBPACK FOOTER //
// ./src/ajax/index.js